import React, { useEffect, Fragment, useState, memo } from 'react'
import { Button, Modal, Card, Row, Col, Form } from 'react-bootstrap'
import CustomTable from './CustomTable';
import AmparosCasoTable from './AmparosCasoTable';
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { Auth, LoadingComponent } from 'recupero-comunes';
import { serviceGetComboMonedas, serviceGetInforme, serviceGetMovimientos } from '../../api/api-consulta-movimients';
import { formato_monto } from '../../common/Formatos';
import { descargarArchivo } from '../../common/descargarArchivo';


const ConsultaMovimientos = ({ showModal, setShowModal, codClasCaso, idCaso, idOrgCaso }) => {
    const { codMonedaLocal, codMonedaConsolida } = Auth.currentUser();
    const [loading, setLoading] = useState(false);
    const [monedas, setMonedas] = useState("");
    const [stateMoneda, setStateMoneda] = useState("");

    const [pretensiones, setPretensiones] = useState([]);
    const [provisiones, setProvisiones] = useState([]);
    const [propuestaIndemniza, setPropuestaIndemniza] = useState([]);
    const [solicitudPago, setSolicitudPago] = useState([]);
    const [amparosCaso, setAmparosCaso] = useState([]);

    const [showPretensiones, setShowPretensiones] = useState(false);
    const [showProvisiones, setShowProvisiones] = useState(false);
    const [showPropuestaIndemniza, setShowPropuestaIndemniza] = useState(false);
    const [showSolicitudPago, setShowSolicitudPago] = useState(false);
    const [showAmparosCaso, setShowAmparosCaso] = useState(false);

    useEffect(() => {
        if (showModal) getMonedas();
    }, [showModal])

    useEffect(() => {
        if (showModal) { setLoading(true); loadMovimientos() }
    }, [stateMoneda])

    const getMonedas = async () => {
        const paisOrganizacion = Auth.currentUser().paisOrganizacion;
        const query = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');

        const response = await serviceGetComboMonedas(query);
        setMonedas(response);
        setStateMoneda(codMonedaLocal);
        
        setLoading(true);
        loadMovimientos()
    }

    const loadMovimientos = async () => {

        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, codMoneda: stateMoneda })).toString('base64');

        const response = await serviceGetMovimientos(query);
        setLoading(false)
        setPretensiones(response?.pretensiones || []);
        setProvisiones(response?.provisiones || []);
        setPropuestaIndemniza(response?.propuestasIndemnizacion || []);
        setSolicitudPago(response?.pagosIndemnizar || []);
        setAmparosCaso(response?.amparosCaso || []);
    }

    const handleChange = (action) => {
        if (action === "pretensiones") setShowPretensiones(!showPretensiones);
        else if (action === "provisiones") setShowProvisiones(!showProvisiones);
        else if (action === "indemniza") setShowPropuestaIndemniza(!showPropuestaIndemniza);
        else if (action === "amparos") setShowAmparosCaso(!showAmparosCaso);
        else setShowSolicitudPago(!showSolicitudPago);
    }

    const handleInforme = async (data) => {
        if (data.idfolioCargaDocto) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: data.idImplicadoCaso,
                idCompania: idOrgCaso,
                idfolioCarga: data.idfolioCargaDocto
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            descargarArchivo(response);
        }
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setShowPretensiones(false);
        setShowProvisiones(false)
        setShowPropuestaIndemniza(false);
        setShowSolicitudPago(false);
        setShowAmparosCaso(false);
        setStateMoneda("");
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        CONSULTA DE MOVIMIENTOS - Caso {idCaso}
                    </Card.Header>
                    <Card.Body>
                        <Row className='containerHeader'>
                            <Col md='5'>
                                <Form.Group as={Row}>
                                    <Form.Label column sm="3">
                                        Moneda
                                    </Form.Label>
                                    <Col sm="8">
                                        <Form.Select
                                            name='stateMoneda'
                                            onChange={(e) => setStateMoneda(e.target.value)}
                                            value={stateMoneda}>

                                            {monedas && monedas
                                                .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                                .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                            }
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col md='1'>
                                <Button className='w-auto' variant='outline-info' onClick={handleCloseModal}>Volver</Button>
                            </Col>
                        </Row>
                        <hr style={{ borderTop: '3px solid #04005D' }}></hr>

                        <Card className='mb-4'>
                            <Card.Header className="customHeaderCard">
                                <span className='cursor' onClick={() => handleChange('pretensiones')}>Pretensiones</span>
                                {showPretensiones ? <FaCaretUp size={20} /> : <FaCaretDown size={20} />}
                            </Card.Header>
                            {showPretensiones &&
                                <Card.Body className="customCard">
                                    <CustomTable data={pretensiones} handleInforme={(data) => handleInforme(data)} movimiento='Pretensiones' showAbogadoObs />
                                </Card.Body>
                            }
                        </Card>
                        <Card className='mb-4'>
                            <Card.Header className="customHeaderCard">
                                <span className='cursor' onClick={() => handleChange('indemniza')}>Valorizaciones PEC</span>
                                {showPropuestaIndemniza ? <FaCaretUp size={20} /> : <FaCaretDown size={20} />}
                            </Card.Header>
                            {showPropuestaIndemniza &&
                                <Card.Body className="customCard">
                                    <CustomTable data={propuestaIndemniza} handleInforme={(data) => handleInforme(data)} movimiento='Propuesta Indemnización' isPEC />
                                </Card.Body>
                            }
                        </Card>
                        <Card className='mb-4'>
                            <Card.Header className="customHeaderCard">
                                <span className='cursor' onClick={() => handleChange('provisiones')}>Reservas</span>
                                {showProvisiones ? <FaCaretUp size={20} /> : <FaCaretDown size={20} />}
                            </Card.Header>
                            {showProvisiones &&
                                <Card.Body className="customCard">
                                    <CustomTable data={provisiones} handleInforme={(data) => handleInforme(data)} movimiento='Provisiones'/>
                                </Card.Body>
                            }
                        </Card>
                        <Card className='mb-4'>
                            <Card.Header className="customHeaderCard">
                                <span className='cursor' onClick={() => handleChange('solicitud')}>Solicitud Pago Implicado</span>
                                {showSolicitudPago ? <FaCaretUp size={20} /> : <FaCaretDown size={20} />}
                            </Card.Header>
                            {showSolicitudPago &&
                                <Card.Body className="customCard">
                                    <CustomTable data={solicitudPago} handleInforme={(data) => handleInforme(data)} movimiento='Solicitud Pago'/>
                                </Card.Body>
                            }
                        </Card>
                        <Card>
                            <Card.Header className="customHeaderCard">
                                <span className='cursor' onClick={() => handleChange('amparos')}>Amparos Caso</span>
                                {showAmparosCaso ? <FaCaretUp size={20} /> : <FaCaretDown size={20} />}
                            </Card.Header>
                            {showAmparosCaso &&
                                <Card.Body className="customCard">
                                    <AmparosCasoTable data={amparosCaso} />
                                </Card.Body>
                            }
                        </Card>
                    </Card.Body>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .cardHeader {
                        background-color: #77789b;
                        color: #FFFFFF;
                    }
                    .containerHeader {
                        display: flex;
                        justify-content: space-between;
                    }
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customHeaderCard {
                        background-color: #676999;
                        color: #fff;
                        font-size: 17px;
                        font-weight: 600;
                        text-align: center;
                        text-decoration: underline;
                    }
                    .cursor {
                        cursor: pointer;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaMovimientos